import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { default as Actions } from '../actions';
import { default as ECSActions } from '../../ecs/actions';
import * as CommonActions from '../../common/actions';
import qs from 'qs';

import { Spinner } from '@salesforce/design-system-react';

import '../../ecs/containers/ContentBlock.scss';

const MAX_SSO_ATTEMPTS = 60;
const SSO_CHECK_INTERVAL_MS = 500;

export class ExperimentBlockInit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remainingAttempts: MAX_SSO_ATTEMPTS // number of seconds to wait before giving up on SSO
    };
    this.APP_IDS = {
      alot: '99c00c37-bdfb-4f2e-bfad-d495b7823880',
      qa: '11b10b3b-98e2-4819-80fc-693aa169f901',
      us: 'fa473ac7-df18-4b1a-b418-8065768bc6af',
      eu: 'fa473ac7-df18-4b1a-b418-8065768bc6af'
    };
  }
  queryString(key) {
    return qs.parse(this.props.location.search.substr(1))[key];
  }

  lookupEcsStack() {
    const match = window.location.hostname.match(
      /^ecs\.([^.]*)\.sfmc-einstein\.com/
    );
    const stacks = ['ALOT', 'QA', 'EU', 'US'];
    if (match?.length && match?.length > 1) {
      const stackKey = match[1].toUpperCase();
      if (stacks.find(stack => stack === stackKey)) {
        return stackKey;
      }
    }
  }

  lookupAppId() {
    const stackKey = this.lookupEcsStack();
    if (stackKey) {
      return this.APP_IDS[stackKey.toLowerCase()];
    }
  }

  appId() {
    return (
      this.props.match.params.appId ||
      this.queryString('appId') ||
      this.lookupAppId()
    );
  }

  componentDidMount() {
    const appId = this.appId();
    if (appId) {
      this.props.actions.triggerAuthInSdk(appId);
      this.checkForSSO();
      // Poll for SSO completion
      this.polling = setInterval(
        this.checkForSSO.bind(this),
        SSO_CHECK_INTERVAL_MS
      );
    } else {
      const details = {
        ...this.props.match,
        hostname: window.location.hostname,
        ecsStack: this.lookupEcsStack(),
        appIds: this.APP_IDS,
        appId: this.lookupAppId()
      };
      console.error('Missing appId parameter', details);
    }
  }

  getAuthFrame() {
    // see blocksdk code --
    // triggerAuth creates a hidden iFrame in our document with the class "authframe"
    const authFrames = document.getElementsByClassName('authframe');
    return authFrames && authFrames.length && authFrames[0];
  }

  checkForSSO() {
    try {
      const authFrame = this.getAuthFrame();
      if (authFrame && !authFrame.onload) {
        authFrame.onload = () => {
          const loadedAuthFrame = this.getAuthFrame();
          const href = loadedAuthFrame.contentWindow.location.href.toLowerCase();
          if (href.endsWith('/inactive')) {
            this.props.history.replace(`/inactive?block=true`);
          } else {
            this.props.history.replace(`/experiments/block`);
          }
        };
      }
    } catch (err) {
      console.error('Unexpected error during SSO', err);
    }

    const remainingAttempts = this.state.remainingAttempts - 1;
    if (remainingAttempts === 0) {
      console.error('SSO timed out');
      this.props.history.replace('/error');
    } else {
      this.setState({ remainingAttempts });
    }
  }

  componentWillUnmount() {
    clearInterval(this.polling);
  }

  render() {
    return (
      <div className="spinner">
        <Spinner
          size="large"
          variant="brand"
          assistiveText={{ label: 'Large spinner' }}
        />
      </div>
    );
  }
}

ExperimentBlockInit.contextTypes = {
  router: PropTypes.object
};

ExperimentBlockInit.propTypes = {
  actions: PropTypes.shape({
    triggerAuthInSdk: PropTypes.func
  }),
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    activation: state.ecs.activation
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...Actions, ...ECSActions, ...CommonActions },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExperimentBlockInit);
